import React from 'react';
import {SelectField, SelectInput} from 'react-admin';

const genders = [
  {id: 'RADIO', name: 'questionType.RADIO'},
  {id: 'IMAGE', name: 'questionType.IMAGE'},
]

export const QuestionTypeField = (props) => (
    <SelectField source={props.source} choices={genders} {...props} />
)

export const QuestionTypeInput = (props) => (
    <SelectInput source={props.source} choices={genders} {...props} label="resources.questionType.name"/>
)
